import { Title } from "../../../../../components/Title";
import claimPayIcon from '../../../../../assets/claim-pay-icon.svg';

export const NoAccessTitle = () => <Title title="Oops! You don't have access to the Inspection service.">
  <img alt='claimpay' src={claimPayIcon} />
</Title>